export {
    CorrectionFeedback,
    type CorrectionFeedbackProps,
    type CorrectionFeedbackTexts,
    type UICorrectionFeedback,
} from "./CorrectionFeedback"
